import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RedirectGuard } from './core/guards/redirect.guard';
import { screenSizeResolverResolver } from './core/resolvers/screen-size-resolver.resolver';
import { LoginComponent } from './pages/login/login.component';
import { RaiseReachDateDisputeComponent } from './pages/pages-no-auth/raise-reach-date-dispute/raise-reach-date-dispute.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { AuthCustomerOrderComponent } from './shared/components/layouts/dynamic-component-wrapper/auth-customer-order/auth-customer-order.component';
import { CustomerOrdersComponent } from './shared/components/layouts/dynamic-component-wrapper/customer-orders/customer-orders.component';
import { NoAuthCustomerOrderComponent } from './shared/components/layouts/dynamic-component-wrapper/no-auth-customer-order/no-auth-customer-order.component';

export const routes: Routes = [
  {
    path: 'login',
    pathMatch: 'full',
    resolve: {
      screenSize: screenSizeResolverResolver,
    },
    component: LoginComponent,
  },

  {
    path: 'terms-and-conditions',
    pathMatch: 'full',
    component: TermsAndConditionsComponent,
  },

  {
    path: 'customer-order/:id',
    pathMatch: 'full',
    resolve: {
      screenSize: screenSizeResolverResolver,
    },
    component: NoAuthCustomerOrderComponent,
  },

  {
    path: 'customer/customer-orders',
    pathMatch: 'full',
    resolve: {
      screenSize: screenSizeResolverResolver,
    },
    canActivate: [AuthGuard],

    component: CustomerOrdersComponent,
  },

  {
    path: 'customer/customer-order/:id',
    pathMatch: 'full',
    resolve: {
      screenSize: screenSizeResolverResolver,
    },
    canActivate: [AuthGuard],

    component: AuthCustomerOrderComponent,
  },

  {
    path: 'raise-dispute/:id',
    pathMatch: 'full',
    component: RaiseReachDateDisputeComponent,
  },

  {
    path: 'redirect',
    canActivate: [AuthGuard, RedirectGuard],
    children: [
      {
        path: '**',
        canActivate: [AuthGuard, RedirectGuard],
        children: [],
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

// suggestion: replace: EmptyComponentComponent => PlaceholderComponent
